import { IDeserializer } from "./IDeserializer";

export abstract class Deserializer<T> implements IDeserializer<T> {
    deserialize(json: any): T {
        return json as T;
    };
    deserializeAll(json: any): T[] {
        return json.map((j: any) => this.deserialize(j));
    };
}